import * as React from 'react';

import {BulletedList} from 'shells/bulleted-list/bulleted-list';
import {OnboardingBody} from 'shells/onboarding-page/onboarding-body';

export function Intro() {
    return (
        <OnboardingBody title='Organize your leads with channels'>
            <p>
                Existing sources can now be grouped into channels. These broad, predetermined
                categories describe where a lead comes from:
            </p>
            <BulletedList
                size='small'
                bullets={[
                    <span key='1'>
                        <strong>Organic search</strong>: Searched Google or another search engine
                    </span>,
                    <span key='2'>
                        <strong>Paid search</strong>: Clicked your ad on Google or other search
                        engine
                    </span>,
                    <span key='3'>
                        <strong>Organic social</strong>: Visited your site from Twitter, Facebook,
                        etc.
                    </span>,
                    <span key='4'>
                        <strong>Paid social</strong>: Clicked your ad on Twitter, Facebook, etc.
                    </span>,
                    <span key='5'>
                        <strong>Email</strong>: Clicked a link in your email campaign
                    </span>,
                    <span key='6'>
                        <strong>Direct traffic</strong>: Navigated directly to your website etc.
                    </span>,
                    <span key='7'>
                        <strong>Referral traffic</strong>: Arrived from a third-party website
                    </span>,
                    <span key='8'>
                        <strong>Traditional</strong>: Saw a billboard, connected at a tradeshow,
                        etc. engine
                    </span>,
                ]}
            />
        </OnboardingBody>
    );
}
